import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getServiceList: EvokeAction<AppState, AppActions> = async (store) => {
  try {
    const services = await api.get("services/all");
    await store.update((state) => {
      state.service = services;
    });
  } catch (error) {
    console.log("error", error);
  }
};
const getConfigurationsList: EvokeAction<AppState, AppActions> = async (
  store
) => {
  try {
    const configurations = await api.get("services/all");
    await store.update((state) => {
      state.configurations = configurations;
    });
  } catch (error) {
    console.log("error", error);
  }
};
const getTablesForService: EvokeAction<AppState, AppActions> = async (
  store,
  service_name: string
) => {
  try {
    const tables = await api.get(`services/${service_name}/tables`);
    await store.update((state) => {
      state.tablesofService = tables;
    });
  } catch (error) {
    console.log("error", error);
  }
};
const resyncTables: EvokeAction<AppState, AppActions> = async (
  store,
  values: object
) => {
  try {
    await api.patch(`services/sync/update`, {}, values);
    console.log("success: ", values);
  } catch (error) {
    console.log("error", error);
    //throw error
  }
};
export const resyncActions = {
  getConfigurationsList,
  getServiceList,
  getTablesForService,
  resyncTables,
};
